/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_KeyInputs */

const en_tables_rule_sets_key = /** @type {(inputs: Tables_Rule_Sets_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Key`)
};

const de_tables_rule_sets_key = /** @type {(inputs: Tables_Rule_Sets_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel`)
};

/**
* | output |
* | --- |
* | "Sets Key" |
*
* @param {Tables_Rule_Sets_KeyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_key = /** @type {((inputs?: Tables_Rule_Sets_KeyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_KeyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_key(inputs)
	return de_tables_rule_sets_key(inputs)
});